import { useEffect, useRef } from "react";
import { offSocketEvent, onSocketEvent } from "../services/SocketService";

const useSocket = ({ event, handler, enabled = true }) => {
   const handlerRef = useRef(handler);

   // keep ref aligned with latest closure so subscribers can pass inline handlers safely
   useEffect(() => {
      handlerRef.current = handler;
   });

   useEffect(() => {
      if (!enabled || !event) return undefined;
      const wrapped = (payload) => handlerRef.current?.(payload);
      onSocketEvent(event, wrapped);
      return () => offSocketEvent(event, wrapped);
   }, [event, enabled]);
};

export default useSocket;
